import React from "react";
import { BrowserRouter as Router, Switch, Redirect } from "react-router-dom";
import { Container } from "react-bootstrap";
import ReportsView from "./components/ReportsView";
import UsersView from "./components/UsersView";
import UsersSingleView from "./components/UsersSingleView";
import UserGroupsView from "./components/UserGroupsView";
import UserGroupsSingleView from "./components/UserGroupsSingleView";
import HeaderNav from "./components/HeaderNav/HeaderNav";
import AuthenticatedRoute from "./components/AuthenticatedRoute";
import CreateUpdateUserView from "./components/CreateUpdateUserView";
import SettingsView from "./components/SettingsView/SettingsView";
import CampaignsView from "./components/CampaignsView";
import CampaignView from "./components/CampaignView";
import WorkflowsView from "./components/WorkflowsView";
import WorkflowView from "./components/WorkflowView";
import WorkflowEditView from "./components/WorkflowView/WorkflowEdit/WorkflowEditView";
import CreateUpdateCampaignView from './components/CreateUpdateCampaignView';
import TeamView from "./components/TeamView";

// Styles
import "./App.scss";
import { withTheme } from "styled-components";

import IdentityContext from './components/IdentityContext';
import ProjectProvider from './components/ProjectContext';
import SitesListView from './components/SitesListView/SitesListView';
import SitesSingleView from './components/SitesSingleView/SitesSingleView';


function App(props) {
  return (
    <Router>
      <IdentityContext>
        <ProjectProvider>
          <HeaderNav></HeaderNav>
          <Container>
            <Switch>
              <AuthenticatedRoute exact path="/users/:project/create">
                <CreateUpdateUserView action="create" />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/users/:project/:userId/update">
                <CreateUpdateUserView action="update" />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/users/:project">
                <UsersView />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/users/:project/:userId">
                <UsersSingleView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/campaigns/:project/create">
                <CreateUpdateCampaignView action="create" />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/groups/:project">
                <UserGroupsView />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/groups/:project/:groupId">
                <UserGroupsSingleView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/reports">
                <ReportsView />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/settings/:project">
                <SettingsView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/sites/:project">
                <SitesListView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/sites/:project/:siteId">
                <SitesSingleView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/campaigns/:project">
                <CampaignsView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/campaigns/:project/:campaignId">
                <CampaignView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/campaigns/:project/create">
                <CreateUpdateCampaignView action="create" />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/campaigns/:project/:campaignId/update">
                <CreateUpdateCampaignView action="update" />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/workflows/:project">
                <WorkflowsView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/workflows/:project/:workflowId">
                <WorkflowView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/workflows/:project/:workflowId/update">
                <WorkflowEditView />
              </AuthenticatedRoute>
              <AuthenticatedRoute exact path="/team/:project">
                <TeamView />
              </AuthenticatedRoute>

              <AuthenticatedRoute exact path="/">
                <Redirect to="/groups" />
              </AuthenticatedRoute>
              {/* <Route path="/signin">
              <h2>Signin</h2>
            </Route> */}
            </Switch>
          </Container>
        </ProjectProvider>
      </IdentityContext>
    </Router>
  );
}

export default withTheme(App);
